export default {
    modelValue: {
        type: [String, Date],
        default: undefined
    },
    animation: {
        type: [Boolean, Object],
        default: undefined
    },
    culture: {
        type: String,
        default: undefined
    },
    dateInput: {
        type: Boolean,
        default: undefined
    },
    dates: {
        type: Array,
        default: undefined
    },
    format: {
        type: String,
        default: undefined
    },
    interval: {
        type: Number,
        default: undefined
    },
    max: {
        type: Date,
        default: undefined
    },
    min: {
        type: Date,
        default: undefined
    },
    parseFormats: {
        type: Array,
        default: undefined
    },
    value: {
        type: [String, Date],
        default: undefined
    },

    // Events
    change: Function,
    close: Function,
    open: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-dateinputs-vue-wrapper/src/KendoTimePicker/TimePickerProps.js